module.exports = __webpack_public_path__ + "img/custom-item3-4.ef85054.png";